import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { initSentry } from './lib/sentry.js';
import { ToastProvider } from './components/feedback/ToastProvider.jsx';
import { DialogProvider } from './components/feedback/DialogProvider.jsx';
import App from './App.jsx';
import './styles/global.css';

initSentry();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ToastProvider>
          <DialogProvider>
            <App />
          </DialogProvider>
        </ToastProvider>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
);
